<template>
  <div>
    <model-form
      ref="modelForm"
      :model="registerGrid"
    >
      <div class="column items-center">
        <div style="width: 100%; max-width: 700px; min-width: 550px;">
          <div
            class="text-h5 q-mb-sm"
          >
            Details
          </div>
          <div class="row q-col-gutter-sm">
            <q-input
              v-model="registerGrid.name"
              class="col-4"
              label="Name"
              :rules="[val => !!val || 'Field is required']"
              bottom-slots
              :autofocus="!$q.platform.is.ios"
            />
          </div>
        </div>
        <div class="q-my-sm" />

        <div
          style="width: 100%; max-width: 700px; min-width: 550px;"
        >
          <div class="text-h5 q-mb-sm">
            Buttons
          </div>

          <q-responsive
            :ratio="1.05"
          >
            <register-button-page
              class="bg-grey-3 q-px-xs q-py-xs"
              :edit-mode="true"
              :register-grid="registerGrid"
            />
          </q-responsive>
        </div>
      </div>
    </model-form>
  </div>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import RegisterButtonPage from 'src/modules/register/components/register-button/RegisterButtonPage'

export default {
  name: 'RegisterGridForm',
  components: {
    ModelForm,
    RegisterButtonPage
  },
  models: {
    registerGrid: {
      registerButtons: {
        item: 'default',
        discounts: 'default',
        itemVariation: {
          item: {
            itemVariations: {
              item: 'default'
            },
            itemModifierSets: {
              defaultModifiers: 'default',
              modifierSet: {
                modifiers: 'default'
              }
            }
          }
        },
        voucherType: {
          itemVariation: 'default'
        }
      },
      libraryChildSiteIds: true
    }
  },
  methods: {
    show (model, initialData) {
      this.$refs.modelForm.show(model, initialData)
    }
  }
}
</script>
